import React, { useState, useEffect } from "react";
import CompleteCase from "../../../../models/CompleteCase";
import { Table, Button, Header, Icon } from "semantic-ui-react";
import CaseType from "../../../../models/CaseType";
import FileLabel from "../../../common/FileLabel";
import Case from "../../../../models/Case";
import CaseRepository from "../../../../common/repository/CaseRepository";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import constants from "../../../../common/constants";
import AllocatedClaimAnalyst from "../../../../models/AllocatedClaimAnalyst";
import InvestigationCard from "./actions/ActionQualityCheck/InvestigationCard";
import LocalStorage from '../../../../lib/LocalStorage';
import config from "../../../../common/repository/config";
import { useHistory } from "react-router-dom";
import CaseFormInputDate from "../CaseFormInputDate";
import axios from "axios";

interface CaseSummaryProps {
  model: CompleteCase;
  updateModel(c: Case): void;

}
interface InsuredOldData {
  claim_number:string,
  insured_name: string,
  insured_phone: string
}

const calculateHours = (startDate: Date, endDate: Date) => {
  // body...

  // Store minutes worked
  let minutesWorked = 0;

  // Validate input
  if (endDate < startDate) {
    return 0;
  }

  // Loop from your Start to End dates (by hour)
  let current = startDate;

  // Define work range
  let workHoursStart = 9;
  let workHoursEnd = 18;
  let includeWeekends = false;

  // Loop while currentDate is less than end Date (by minutes)
  while (current <= endDate) {
    // Is the current time within a work day (and if it
    // occurs on a weekend or not)
    if (
      current.getHours() >= workHoursStart &&
      current.getHours() < workHoursEnd &&
      (includeWeekends
        ? current.getDay() !== 0 && current.getDay() !== 6
        : true)
    ) {
      minutesWorked++;
    }

    // Increment current time
    current.setTime(current.getTime() + 1000 * 60);
  }

  // Return the number of hours
  return Math.ceil(minutesWorked / 60);
};

const dateToDaysString = (startDate: Date, endDate: Date) => {
  let hrs = calculateHours(startDate, endDate);
  let avTAT = "";
  let days = Math.floor(hrs / 9);
  let hours = hrs % 9;
  if (days > 1) avTAT = `${days} Days `;
  else if (days == 1) avTAT = `${days} Day `;
  if (hours > 0) avTAT += `${hours} Hours`;
  return avTAT;
};

let newAllocate: any
const getAllocationDate = async (case_id: string) => {
  let caseRepo = new CaseRepository();
  const result = await caseRepo.getQCData({ case_id: case_id });

  if (result instanceof Result.Success) {
    const qcData = result.data;
    newAllocate = qcData.getAllocations()
    const values = qcData
      .getAllocations()
      .map((it, i) => getMimumAllocationDate(`${i}`, it));
    let min_dt = values[0],
      min_dtObj = new Date(values[0]);
    values.forEach(function (dt, index) {
      if (new Date(dt) < min_dtObj) {
        min_dt = dt;
        min_dtObj = new Date(dt);
      }
    });
    return min_dt;
  } else {
    const message = result.message || "Something went wrong";
    // toast.error(message);
  }
};

const getMimumAllocationDate = (
  fakeId: string,
  allocatedClaimAnalyst: AllocatedClaimAnalyst
) => {
  const value = { ...InvestigationCard.initialValue };

  value.id = fakeId;
  value.claimAnalystId = allocatedClaimAnalyst.getClaimAnalyst().getId();
  const allocationDates = allocatedClaimAnalyst
    .getAllocatedInvestigators()
    .map((it) => {
      return new Date(it.getAllocatedOn());
    });
  let min_dt = allocationDates[0],
    min_dtObj = new Date(allocationDates[0]);
  allocationDates.forEach(function (dt, index) {
    if (new Date(dt) < min_dtObj) {
      min_dt = dt;
      min_dtObj = new Date(dt);
    }
  });

  return min_dt;
};

const CaseSummary = (props: CaseSummaryProps) => {
  const caseRepo = new CaseRepository();
  const { model, updateModel } = props;
  const history = useHistory();
  const portalRoot = document.getElementsByTagName("body")[0];
  const [hidden, setHidden] = useState(true);
  const [loading, setloading] = useState(false);
  const [insuredOldData, setInsuredOldData] = useState<any[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [acceptedIds, setAcceptedIds] = useState<any[]>([]);
  const [refCaseIds, setRefCaseIds] = useState<any[]>([]);
  const [qc_insured_dob, set_qc_insured_dob] = useState("");
  const company = model.getInsuranceCompany();
  const companyName = model.getInsuranceCompanyName();
  const tpa = model.getTPA();
  const insuredLocation = model.getInsuredLocation();
  const hospital = model.getHospital();
  let [allocationDate, setAllocationDate] = useState<Date | undefined>(
    undefined
  );
  const [documentsSize, setDocumentsSize] = useState(0);

  let [flag, setFlag] = useState(0);

  if (flag == 0) {
    (async () => {
      let tmp = await getAllocationDate(model.getId());
      setAllocationDate(tmp);
    })();
    setFlag(1);
  }

  const triggerInsuredFeedback = async () => {
    setloading(true);
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');
      console.log(model.getState())
      if (!model.getState()) return null;
      if (model.getState() !== constants.caseStates.fold && model.getState() !== constants.caseStates.checked && model.getState() !== constants.caseStates.close && model.getState() !== constants.caseStates.graded) {
        const payload = {
          caseId: model.getId(),
          insuredName: model.getInsuredName(),
          district: model.getInsuredLocation()?.getDistrict(),
          dob: model.getDob() ?? ""
        };
    
        const response = await fetch(`${config.apiBaseURL}/case/insuredFeedback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
          body: JSON.stringify(payload), 
        });
    
        if (!response.ok) {
          const errorText = await response.json();
          toast.error(`${errorText.message || "Something went wrong"}`);
          return;
        }
    
        const data = await response.json();
        if (data.success) {
          console.log(model.getInsuredContact(),model.getInsuredName());
          setInsuredOldData(data.data.items);
          toast.success(`${data.message}`);
        } else {
          toast.error(`${data.message}`);
        }
      } else {
        console.log("here")
        const payload = {
          caseId: model.getId(),
        };
    
        const response = await fetch(`${config.apiBaseURL}/case/getRefcases`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token,
          },
          body: JSON.stringify(payload), 
        });
    
        if (!response.ok) {
          const errorText = await response.json();
          toast.error(`${errorText.message || "Something went wrong"}`);
          return;
        }
    
        const data = await response.json();
        if (data.success) {
          console.log(model.getInsuredContact(),model.getInsuredName());
          setInsuredOldData(data.data.items);
          toast.success(`${data.message}`);
        } else {
          toast.error(`${data.message}`);
        }
      }
    } catch (e) {
      toast.error(e as string);
    } finally {
      setloading(false);
    }
  }

  const handleCompare = (value: string) => {
   if (model.getDob() !== value) {
     setOpenModal(true);
   } else {
     setOpenModal(false);
   }
  };
  const isQualtativeEnabled =
    model.getState() !== constants.caseStates.fold &&
    model.getState() !== constants.caseStates.checked &&
    model.getState() !== constants.caseStates.close &&
    model.getState() !== constants.caseStates.graded;

  const handleAccept = (id: string) => {
    if (acceptedIds.includes(id)) {
      setAcceptedIds((prev) => prev.filter((item) => item !== id));
    } else {
      setAcceptedIds((prev) => {
        if (prev.includes(id)) return prev;
        return [...prev, id];
      });
    }
  };

  const handleLink = (id: string) => {
    if(refCaseIds.includes(id)) {
      setRefCaseIds((prev) => prev.filter((item) => item !== id));
    } else {
      setRefCaseIds((prev) => {
        if (prev.includes(id)) return prev;
        return [...prev, id];
      });
    }
  };
  
  const triggerGenerateReport = async () => {

    const token =
      LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Auth token missing");
      return;
    }

    try {

      setloading(true);

      toast.success(
        "Download will start shortly!"
      );

      const caseIds = [
        ...acceptedIds,
        model.getId()
      ];

      const response = await fetch(
        `${config.apiBaseURL}/case/generateQuantativeReport`,
        {
          method: "POST",

          headers: {
            "x-access-token": token,
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            caseIds
          })
        }
      );

      if (!response.ok) {

        toast.error(
          "Unable to generate report"
        );

        return;
      }

      const blob =
        await response.blob();

      const fileURL =
        window.URL.createObjectURL(blob);
        
      const link =
        document.createElement("a");

      link.href = fileURL;

      link.download =
        "QuantativeReport.xlsx";

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(fileURL);

      toast.success(
        "Report downloaded successfully!"
      );

    } catch (e) {

      console.log(e);

      toast.error(
        "Something went wrong while downloading report!"
      );

    } finally {

      setloading(false);

    }

  };

  const triggerGenerateQualtativeReport = async () => {
    const token =
      LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);

    if (!token) {
      toast.error("Auth token missing");
      return;
    }

    try {

      setloading(true);

      toast.success(
        "Download will start shortly!"
      );

      const response = await fetch(
        `${config.apiBaseURL}/case/generateQualtativeReport`,
        {
          method: "POST",

          headers: {
            "x-access-token": token,
            "Content-Type": "application/json"
          },

          body: JSON.stringify({
            caseId: model.getId()
          })
        }
      );

      if (!response.ok) {

        toast.error(
          "Unable to generate report"
        );

        return;
      }

      const blob =
        await response.blob();

      const fileURL =
        window.URL.createObjectURL(blob);
        
      const link =
        document.createElement("a");

      link.href = fileURL;

      link.download =
        "QualtataiveReport.docx";

      document.body.appendChild(link);

      link.click();

      link.remove();

      window.URL.revokeObjectURL(fileURL);

      toast.success(
        "Report downloaded successfully!"
      );

    } catch (e) {

      console.log(e);

      toast.error(
        "Something went wrong while downloading report!"
      );

    } finally {

      setloading(false);

    }
  };

  const linkCases = async () => {
    setloading(true);
    try {
      const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
      if (!token) throw new Error('Authentication token is missing.');
    
      const payload = {
        caseId: model.getId(),
        refCaseId: refCaseIds
      };

      const response = await fetch(`${config.apiBaseURL}/case/linkRefCase`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token,
        },
        body: JSON.stringify(payload), 
      });
  
      if (!response.ok) {
        const errorText = await response.json();
        toast.error(`${errorText.message || "Something went wrong"}`);
        return;
      }
  
      const data = await response.json();
      if (data.success) {
        toast.success(`${data.message}`);
      } else {
        toast.error(`${data.message}`);
      }
    } catch (e) {
      toast.error(e as string);
    } finally {
      setloading(false);
    }  
  }

  const getClaimSize = async (claimNumber: string) => {
    let caseRepo = new CaseRepository();
    const result = await caseRepo.getClaimSize(claimNumber.toLowerCase());
    if (result instanceof Result.Success) {
      return result.data[0] as { documents_size: number; evidences_size: number };
    } else {
      const message =
        result.message || "Something went wrong while fetching Claim Size";
      toast.error(message);
      return false;
    }
  };
  useEffect(() => {
    (async () => {
      const rs = await getClaimSize(model.getClaimNumber());
      if (rs && typeof rs !== "boolean") {
        setDocumentsSize(rs.documents_size);
      }
    })();
  }, [model]);

  return (
    <>
      {(model.getReinvestigation() || model.getPushback()) ?
        ( 
          <>
            <Table color={"olive"} striped compact celled structured>
              <Table.Body style={{ fontWeight: 500 }}>
                <Table.Row positive>
                  <Table.Cell width={3}>TPA/Company Names</Table.Cell>
                  <Table.Cell>
                    {tpa !== null
                      ? `${tpa.getName()}`
                      : company !== null
                        ? company.getName()
                        : companyName}
                  </Table.Cell>

                  <Table.Cell width={3}>Claim Number</Table.Cell>
                  <Table.Cell width={3}>{model.getClaimNumber()}</Table.Cell>
                </Table.Row>

              <Table.Row>
                <Table.Cell>Case Type</Table.Cell>
                    <Table.Cell>
                      <div style={{display: "flex", justifyContent: "space-between"}}>
                        <div>
                          {model.getType().getTitle()} 
                        </div>
                        <div>
                          {model.getType().getInitialCasePortionCapping()}
                        </div>
                        
                      </div>
                  </Table.Cell>
                

                  <Table.Cell>Claim Amount</Table.Cell>
                  <Table.Cell>{model.getPolicyNumber()}</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Insured Name</Table.Cell>
                          <Table.Cell>
                            <div style={{display:"flex", justifyContent: "space-between", alignItems: "center"}}>
                              {model.getInsuredName()}
                              <Button size="small" icon style={{ backgroundColor: "#2185d0", color: "#fff" }} onClick={triggerInsuredFeedback} disabled = {loading}>
                                <Icon name="search"  /> Feedback Analysis
                              </Button> 
                            </div>
                          
                          </Table.Cell>
                  <Table.Cell>Insured Location</Table.Cell>
                  <Table.Cell>
                    {insuredLocation !== null
                      ? `${insuredLocation.getDistrict()}, ${insuredLocation.getState()}`
                      : ""}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Insured Address</Table.Cell>
                  <Table.Cell>{model.getInsuredAddress()}</Table.Cell>
                  <Table.Cell>Date of Birth</Table.Cell>
                  <Table.Cell>{model.getDob() ?? "N/A"}</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Hospital</Table.Cell>
                  <Table.Cell>{hospital?.getName()}</Table.Cell>
                  <Table.Cell>Hospital Location</Table.Cell>
                  <Table.Cell>
                    {hospital?.getDistrict()}, {hospital?.getState()}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Policy Type</Table.Cell>
                  <Table.Cell>{model.getPolicyType().getTitle()}</Table.Cell>
                  <Table.Cell>Policy Inception</Table.Cell>
                  <Table.Cell>{model.getPolicyInception()}</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Triggers</Table.Cell>
                  <Table.Cell colSpan={3}>
                    {model
                      .getTriggers()
                      .split("\n")
                      .map((it) => {
                        return <div>{it}</div>;
                      })}
                  </Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Documents :{documentsSize > 0 && (
                    <span style={{ fontWeight: "bold", marginLeft: "1rem", color: "blue" }}>
                      Size: {formatBytes(documentsSize)}
                    </span>
                  )}</Table.Cell>
                  <Table.Cell colSpan={3}>
                    <FileLabel.Group horizontal>
                      {model.getDocuments().map((it) => {
                        let removable = true;
                        if (model.getDocuments().length === 1) removable = false;
                        return (
                          <FileLabel
                            title={it.getFullName().slice(0, 30)}
                            link={it.getURL()}
                            removable={removable}
                            remove={async () => {
                              const result = await caseRepo.removeDocument({
                                id: model.getId(),
                                document_url: it.getURL(),
                              });
                              if (result instanceof Result.Success) {
                                const c = result.data;
                                updateModel(c);
                                toast.success("Document removed successfully");
                                return true;
                              } else {
                                const message =
                                  result.message || "Something went wrong";
                                toast.error(message);
                                return false;
                              }
                            }}
                          />
                        );
                      })}
                    </FileLabel.Group>


                  </Table.Cell>
                </Table.Row>

                {/*{!hidden && (*/}
                {/*    <>*/}
                <Table.Row>
                  <Table.Cell>Case Category</Table.Cell>
                  <Table.Cell>{model.getCategory().getTitle()}</Table.Cell>
                  <Table.Cell>Inward DateTime</Table.Cell>
                  <Table.Cell>{model.getInwardDateTime()}</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>Subject Line</Table.Cell>
                  <Table.Cell>{model.getSubjectLine()}</Table.Cell>
                  <Table.Cell>Insured Contact</Table.Cell>
                  <Table.Cell>{model.getInsuredContact()}</Table.Cell>
                </Table.Row>

                <Table.Row>
                  {/* <Table.Cell>TAT</Table.Cell>
                  <Table.Cell>
                    {CaseType.formatTAT(model.getAvailableTAT())}
                  </Table.Cell> */}
                  {(model.getState() == constants.caseStates.close ||
                    model.getState() == constants.caseStates.graded) && (
                      <>
                        <Table.Cell>Closure TAT</Table.Cell>
                        <Table.Cell>
                          {dateToDaysString(
                            new Date(model.getInwardDateTime()),
                            new Date(model.getClosedOn()!)
                          )}
                        </Table.Cell>
                      </>
                    )}
                  {model.getState() != constants.caseStates.close &&
                    model.getState() != constants.caseStates.graded && (
                      <>
                        <Table.Cell>TAT Remaining</Table.Cell>
                        <Table.Cell>
                          {CaseType.formatTAT(model.getRemainingTAT())}
                        </Table.Cell>
                      </>
                    )}
                  {/*<Table.Cell>{CaseType.formatTAT(model.)}</Table.Cell>*/}
                </Table.Row>
                {(model.getState() == constants.caseStates.close ||
                  model.getState() == constants.caseStates.graded) && (
                    <Table.Row>
                      <Table.Cell>Closure Remarks</Table.Cell>
                      <Table.Cell colSpan={3}>{model.getFinalRemarks()}</Table.Cell>
                    </Table.Row>
                  )}
                {(model.getState() == constants.caseStates.close ||
                  model.getState() == constants.caseStates.graded) && (
                    <Table.Row>
                      <Table.Cell>Allocation Delay</Table.Cell>
                      <Table.Cell colSpan={3}>
                        {dateToDaysString(
                          new Date(model.getInwardDateTime()),
                          allocationDate!
                        )}
                      </Table.Cell>
                    </Table.Row>
                  )}

                {/*</>*/}
                {/*)}*/}
              </Table.Body>
            </Table>
            {
              insuredOldData.length > 0 && (
                      <Table
                        striped
                        compact
                        celled
                        style={{
                          marginTop: "1rem",
                          borderRadius: "10px",
                          overflow: "hidden",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                        }}
                      >
                        <Table.Header>
                          <Table.Row>
                            {["Claim Number", "Insured Name", "Insured Phone", "DOB","Outcome", "Actions"].map((heading) => (
                              <Table.HeaderCell
                                key={heading}
                                style={{
                                  backgroundColor: "#2c7fb8",
                                  color: "#fff",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  fontSize: "13px",
                                  padding: "12px"
                                }}
                              >
                                {heading}
                              </Table.HeaderCell>
                            ))}
                          </Table.Row>
                        </Table.Header>
                        <Table.Body>
                          {insuredOldData.map((item) => {
                            const insuredContactMatch = String(model.getInsuredContact() || "") === String(item.insured_phone || "");

                            const dobMatch =
                              !!model.getDob() &&
                              !!item.dob &&
                              String(model.getDob()).toLowerCase() === String(item.dob).toLowerCase();

                            const isMatch = insuredContactMatch || dobMatch;
                            return (
                              <Table.Row
                                key={item._id}
                                style={{ 
                                  transition: "all 0.2s ease",
                                  backgroundColor: isMatch ? "#b0e1bd" : "",
                                  borderLeft: isMatch ? "4px solid #21ba45" : ""
                                }}
                                onMouseEnter={(e: any) => {
                                  if (!isMatch) {
                                    e.currentTarget.style.backgroundColor = "#f4f6f8";
                                  }
                                }}
                                onMouseLeave={(e: any) => {
                                  if (!isMatch) {
                                    e.currentTarget.style.backgroundColor = "";
                                  }
                                }}
                              >
                                <Table.Cell
                                  style={{
                                    padding: "12px",
                                    fontSize: "14px",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}
                                >
                                  {item.claim_number}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "12px",
                                    fontSize: "14px",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}
                                >
                                  {item.insured_name}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "12px",
                                    fontSize: "14px",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}
                                >
                                  {item.insured_phone || "N/A"}
                                </Table.Cell>
                                <Table.Cell
                                  style={{
                                    padding: "12px",
                                    fontSize: "14px",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}
                                >
                                  {item.dob || "N/A"}
                                </Table.Cell>  
                                <Table.Cell
                                  style={{
                                    padding: "12px",
                                    fontSize: "14px",
                                    verticalAlign: "middle",
                                    textAlign: "center"
                                  }}
                                >
                                  {item.outcome || "N/A"}
                                </Table.Cell>                       
                                <Table.Cell
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle"
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      gap: "8px"
                                    }}
                                  >
                                    <Button
                                      size="small"
                                      style={{
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        backgroundColor: acceptedIds.includes(item._id) ? "#db2828" : "#21ba45",
                                        color: "#fff",
                                        minWidth: "70px"
                                      }}
                                      onClick={() => handleAccept(item._id)}
                                    >
                                      {acceptedIds.includes(item._id) ? "Decline" : "Accept"}
                                    </Button>
                                    <Button
                                      as="a"
                                      href={`/case/view/${item._id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      size="small"
                                      style={{
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        backgroundColor: "#2185d0",
                                        color: "#fff",
                                        minWidth: "70px"
                                      }}
                                    >
                                      View
                                    </Button>
                                    <Button
                                      size="small"
                                      style={{
                                        borderRadius: "6px",
                                        fontSize: "12px",
                                        backgroundColor: refCaseIds.includes(item._id) ? "#db2828" : "#2185d0",
                                        color: "#fff",
                                        minWidth: "70px"
                                      }}
                                      onClick={() => handleLink(item._id)}
                                    >
                                      {refCaseIds.includes(item._id) ? "Unlink" : "Link"}
                                    </Button>
                                  </div>
                                </Table.Cell>
                              </Table.Row>
                            )
                          })}
                        </Table.Body>
                        <Table.Footer>
                          <Table.Row>
                            <Table.Cell colSpan={6}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "right",
                                  alignItems: "center",
                                  gap: "12px",
                                  flexWrap: "wrap",
                                  padding: "8px 8px 8px 0px"
                                }}
                              >
                                <div>
                                  <Button
                                    icon
                                    labelPosition="left"
                                    disabled={acceptedIds.length === 0 || loading}
                                    style={{
                                      background: "linear-gradient(135deg, #2185d0, #1678c2)",
                                      color: "#fff",
                                      borderRadius: "8px",
                                      fontWeight: 600,
                                      padding: "10px 16px",
                                      boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                                      transition: "all 0.2s ease"
                                    }}
                                    onClick={triggerGenerateReport}
                                  >
                                    <Icon name="file alternate" />
                                    Generate Narrative Report ({acceptedIds.length})
                                  </Button>

                                  <Button
                                    icon
                                    labelPosition="left"
                                    disabled={refCaseIds.length === 0 || loading}
                                    style={{
                                      background: "linear-gradient(135deg, #2185d0, #1678c2)",
                                      color: "#fff",
                                      borderRadius: "8px",
                                      fontWeight: 600,
                                      padding: "10px 16px",
                                      boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                                      transition: "all 0.2s ease"
                                    }}
                                    onClick={linkCases}
                                  >
                                    <Icon name="linkify" />
                                    Link cases ({refCaseIds.length})
                                  </Button>
                                </div>
                              </div>  
                            </Table.Cell>     
                          </Table.Row>
                          <Table.Cell>Case Type</Table.Cell>
                          <Table.Cell>
                            <div style={{display: "flex", justifyContent: "space-between"}}>
                              <div>
                                {model.getType().getTitle()} 
                              </div>
                              <div>
                                {model.getType().getInitialCasePortionCapping()}
                              </div>
                              
                            </div>
                          </Table.Cell>
                        </Table.Footer> 
                      </Table> 
              )
            }
          </>
        )        
        :  
            <>
              <Table striped compact celled structured>
                <Table.Body style={{ fontWeight: 500 }}>
                  <Table.Row >
                    <Table.Cell width={3}>TPA/Company Name</Table.Cell>
                    <Table.Cell>
                      {tpa !== null && company !== null
                        ? `${tpa.getName()} (TPA) - ${company.getName()}`
                        : tpa !== null
                          ? `${tpa.getName()} (TPA)`
                          : company !== null
                            ? company.getName()
                            : companyName}
                    </Table.Cell>

                    <Table.Cell width={3}>Claim Number</Table.Cell>
                    <Table.Cell width={3}>{model.getClaimNumber()}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Case Type</Table.Cell>
                    <Table.Cell>
                      <div style={{display: "flex", justifyContent: "space-between"}}>
                        <div>
                          {model.getType().getTitle()} 
                        </div>
                        <div>
                          {model.getType().getInitialCasePortionCapping()}
                        </div>
                      </div>
                    </Table.Cell>

                    <Table.Cell>Claim Amount</Table.Cell>
                    <Table.Cell>{model.getPolicyNumber()}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Insured Name</Table.Cell>
                      <Table.Cell>
                        <div style={{display:"flex", justifyContent: "space-between", alignItems: "center"}}>
                          {model.getInsuredName()}
                          <Button size="small" icon style={{ backgroundColor: "#2185d0", color: "#fff" }} onClick={triggerInsuredFeedback} disabled = {loading}>
                            <Icon name="search"  /> Feedback Analysis
                          </Button> 
                        </div>
                      
                      </Table.Cell>
                      
                    <Table.Cell>Insured Location</Table.Cell>
                    <Table.Cell>
                      {insuredLocation !== null
                        ? `${insuredLocation.getDistrict()}, ${insuredLocation.getState()}`
                        : ""}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Insured Address</Table.Cell>
                    <Table.Cell>{model.getInsuredAddress()}</Table.Cell>
                    <Table.Cell>Date of Birth</Table.Cell>
                    <Table.Cell>
                    {model.getDob() ?? "N/A"}
                    </Table.Cell>

                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Hospital</Table.Cell>
                    <Table.Cell>{hospital?.getName()}</Table.Cell>
                    <Table.Cell>Hospital Location</Table.Cell>
                    <Table.Cell>
                      {hospital?.getDistrict()}, {hospital?.getState()}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Policy Type</Table.Cell>
                    <Table.Cell>{model.getPolicyType().getTitle()}</Table.Cell>
                    <Table.Cell>Policy Inception</Table.Cell>
                    <Table.Cell>{model.getPolicyInception()}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Triggers</Table.Cell>
                    <Table.Cell colSpan={3}>
                      {model
                        .getTriggers()
                        .split("\n")
                        .map((it) => {
                          return <div>{it}</div>;
                        })}
                    </Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Documents :-{documentsSize > 0 && (
                      <span style={{ fontWeight: "bold", marginLeft: "1rem", color: "blue" }}>
                        Size: {formatBytes(documentsSize)}
                      </span>
                    )}</Table.Cell>

                    <Table.Cell colSpan={3}>
                      <FileLabel.Group horizontal>
                        {model.getDocuments().map((it) => {
                          let removable = true;
                          if (model.getDocuments().length === 1) removable = false;
                          return (
                            <FileLabel
                              title={it.getFullName().slice(0, 30)}
                              link={it.getURL()}
                              removable={removable}
                              remove={async () => {
                                const result = await caseRepo.removeDocument({
                                  id: model.getId(),
                                  document_url: it.getURL(),
                                });
                                if (result instanceof Result.Success) {
                                  const c = result.data;
                                  updateModel(c);
                                  toast.success("Document removed successfully");
                                  return true;
                                } else {
                                  const message =
                                    result.message || "Something went wrong";
                                  toast.error(message);
                                  return false;
                                }
                              }}
                            />
                          );
                        })}
                      </FileLabel.Group>
                    </Table.Cell>
                  </Table.Row>

                  {/*{!hidden && (*/}
                  {/*    <>*/}
                  <Table.Row>
                    <Table.Cell>Case Category</Table.Cell>
                    <Table.Cell>{model.getCategory().getTitle()}</Table.Cell>
                    <Table.Cell>Inward DateTime</Table.Cell>
                    <Table.Cell>{model.getInwardDateTime()}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    <Table.Cell>Subject Line</Table.Cell>
                    <Table.Cell>{model.getSubjectLine()}</Table.Cell>
                    <Table.Cell>Insured Contact</Table.Cell>
                    <Table.Cell>{model.getInsuredContact()}</Table.Cell>
                  </Table.Row>

                  <Table.Row>
                    {/* <Table.Cell>TAT</Table.Cell>
                    <Table.Cell>
                      {CaseType.formatTAT(model.getAvailableTAT())}
                    </Table.Cell> */}
                    {(model.getState() == constants.caseStates.close ||
                      model.getState() == constants.caseStates.graded) && (
                        <>
                          <Table.Cell>Closure TAT</Table.Cell>
                          <Table.Cell>
                            {dateToDaysString(
                              new Date(model.getInwardDateTime()),
                              new Date(model.getClosedOn()!)
                            )}
                          </Table.Cell>
                        </>
                      )}
                    {model.getState() != constants.caseStates.close &&
                      model.getState() != constants.caseStates.graded && (
                        <>
                          <Table.Cell>TAT Remaining</Table.Cell>
                          <Table.Cell>
                            {CaseType.formatTAT(model.getRemainingTAT())}
                          </Table.Cell>
                        </>
                      )}
                    {/*<Table.Cell>{CaseType.formatTAT(model.)}</Table.Cell>*/}
                  </Table.Row>
                  {(model.getState() == constants.caseStates.close ||
                    model.getState() == constants.caseStates.graded) && (
                      <Table.Row>
                        <Table.Cell>Closure Remarks</Table.Cell>
                        <Table.Cell colSpan={3}>{model.getFinalRemarks()}</Table.Cell>
                      </Table.Row>
                    )}
                  {(model.getState() == constants.caseStates.close ||
                    model.getState() == constants.caseStates.graded) && (
                      <Table.Row>
                        <Table.Cell>Allocation Delay</Table.Cell>
                        <Table.Cell colSpan={3}>
                          {dateToDaysString(
                            new Date(model.getInwardDateTime()),
                            allocationDate!
                          )}
                        </Table.Cell>
                      </Table.Row>
                    )}
                  <Table.Row>
                    <Table.Cell>Approved Expense</Table.Cell>
                    <Table.Cell>{model.getApproved_expense()}</Table.Cell>
                    <Table.Cell>Approved Expense Receipt</Table.Cell>
                    <FileLabel.Group horizontal>
                      {model.getApproved_expense_receipt().map((url, index, arr) => {
                        const removable = arr.length > 1;

                        return (
                          <FileLabel
                            key={index}
                            title={url.split('/').pop()?.slice(0, 30) || 'File'}
                            link={url}
                            removable={removable}
                          />
                        );
                      })}
                    </FileLabel.Group>
                  </Table.Row>

                  {/*</>*/}
                  {/*)}*/}
                </Table.Body>
              </Table>
              {insuredOldData.length > 0 && (
                <Table
                  striped
                  compact
                  celled
                  style={{
                    marginTop: "1rem",
                    borderRadius: "10px",
                    overflow: "hidden",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)"
                  }}
                >
                  <Table.Header>
                    <Table.Row>
                      {["Claim Number", "Insured Name", "Insured Phone", "DOB","Outcome", "Actions"].map((heading) => (
                        <Table.HeaderCell
                          key={heading}
                          style={{
                            backgroundColor: "#2c7fb8",
                            color: "#fff",
                            fontWeight: 600,
                            textAlign: "center",
                            fontSize: "13px",
                            padding: "12px"
                          }}
                        >
                          {heading}
                        </Table.HeaderCell>
                      ))}
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {insuredOldData.map((item) => {
                      const insuredContactMatch =
                          String(model.getInsuredContact() || "") === String(item.insured_phone || "");

                      const dobMatch =
                          !!model.getDob() &&
                          !!item.dob &&
                          String(model.getDob()).toLowerCase() === String(item.dob).toLowerCase();

                      const isMatch = insuredContactMatch || dobMatch;
                      return (
                        <Table.Row
                          key={item._id}
                          style={{ 
                            transition: "all 0.2s ease",
                            backgroundColor: isMatch ? "#b0e1bd" : "",
                            borderLeft: isMatch ? "4px solid #21ba45" : ""
                          }}
                          onMouseEnter={(e: any) => {
                            if (!isMatch) {
                              e.currentTarget.style.backgroundColor = "#f4f6f8";
                            }
                          }}
                          onMouseLeave={(e: any) => {
                            if (!isMatch) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          <Table.Cell
                            style={{
                              padding: "12px",
                              fontSize: "14px",
                              verticalAlign: "middle",
                              textAlign: "center"
                            }}
                          >
                            {item.claim_number}
                          </Table.Cell>
                          <Table.Cell
                            style={{
                              padding: "12px",
                              fontSize: "14px",
                              verticalAlign: "middle",
                              textAlign: "center"
                            }}
                          >
                            {item.insured_name}
                          </Table.Cell>
                          <Table.Cell
                            style={{
                              padding: "12px",
                              fontSize: "14px",
                              verticalAlign: "middle",
                              textAlign: "center"
                            }}
                          >
                            {item.insured_phone || "N/A"}
                          </Table.Cell>
                          <Table.Cell
                            style={{
                              padding: "12px",
                              fontSize: "14px",
                              verticalAlign: "middle",
                              textAlign: "center"
                            }}
                          >
                            {item.dob || "N/A"}
                          </Table.Cell>  
                          <Table.Cell
                            style={{
                              padding: "12px",
                              fontSize: "14px",
                              verticalAlign: "middle",
                              textAlign: "center"
                            }}
                          >
                            {item.outcome || "N/A"}
                          </Table.Cell>                      
                          <Table.Cell
                            style={{
                              textAlign: "center",
                              verticalAlign: "middle"
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "8px"
                              }}
                            >
                              <Button
                                size="small"
                                disabled={!isQualtativeEnabled}
                                style={{
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  backgroundColor: acceptedIds.includes(item._id) ? "#db2828" : "#21ba45",
                                  color: "#fff",
                                  minWidth: "70px"
                                }}
                                onClick={() => handleAccept(item._id)}
                              >
                                {acceptedIds.includes(item._id) ? "Decline" : "Accept"}
                              </Button>
                              <Button
                                as="a"
                                href={`/case/view/${item._id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                size="small"
                                style={{
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  backgroundColor: "#2185d0",
                                  color: "#fff",
                                  minWidth: "70px"
                                }}
                              >
                                View
                              </Button>
                              <Button
                                size="small"
                                disabled={!isQualtativeEnabled}
                                style={{
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  backgroundColor: refCaseIds.includes(item._id) ? "#db2828" : "#2185d0",
                                  color: "#fff",
                                  minWidth: "70px"
                                }}
                                onClick={() => handleLink(item._id)}
                              >
                                {refCaseIds.includes(item._id) ? "Unlink" : "Link"}
                              </Button>
                            </div>
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                  <Table.Footer>
                    <Table.Row>
                      <Table.Cell colSpan={6}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "center",
                            gap: "12px",
                            flexWrap: "wrap",
                            padding: "8px 8px 8px 0px"
                          }}
                        >
                          <div>
                            <Button
                              icon
                              labelPosition="left"
                              disabled={acceptedIds.length === 0 || loading || !isQualtativeEnabled}
                              style={{
                                background: "linear-gradient(135deg, #2185d0, #1678c2)",
                                color: "#fff",
                                borderRadius: "8px",
                                fontWeight: 600,
                                padding: "10px 16px",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                                transition: "all 0.2s ease"
                              }}
                              onClick={triggerGenerateReport}
                            >
                              <Icon name="file alternate" />
                              Generate Narrative Report ({acceptedIds.length})
                            </Button>

                            <Button
                              icon
                              labelPosition="left"
                              disabled={refCaseIds.length === 0 || loading || !isQualtativeEnabled}
                              style={{
                                background: "linear-gradient(135deg, #2185d0, #1678c2)",
                                color: "#fff",
                                borderRadius: "8px",
                                fontWeight: 600,
                                padding: "10px 16px",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                                transition: "all 0.2s ease"
                              }}
                              onClick={linkCases}
                            >
                              <Icon name="linkify" />
                              Link cases ({refCaseIds.length})
                            </Button>
                          </div>
                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Footer>
                </Table>
              )} 
              {
              (model.getState() === constants.caseStates.fold || model.getState() === constants.caseStates.checked || model.getState() === constants.caseStates.close || model.getState() === constants.caseStates.graded) && insuredOldData.length > 0 ? 
                <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "15px",
                  marginBottom: "15px"
                }}
                >
                <Button
                  icon
                  labelPosition="left"
                  disabled={loading}
                  style={{
                    backgroundColor: "#2185d0",
                    color: "#fff",
                    borderRadius: "6px",
                    fontWeight: 600,
                    padding: "10px 18px"
                  }}
                  onClick={triggerGenerateQualtativeReport}
                >
                  <Icon name="file alternate outline" />
                  Generate Qualitative Report 
                </Button>
                </div> :
              <></>
              }
            </>
    
      }

      {model.getReinvestigation() && (newAllocate?.map((item: any) => item?.allocatedInvestigators?.map((data: any) =>
        <Table celled selectable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Name</Table.HeaderCell>
              <Table.HeaderCell>Approved Expense</Table.HeaderCell>
              <Table.HeaderCell>MRD Expense</Table.HeaderCell>
              <Table.HeaderCell>Extra Expense</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          < Table.Body >
            <Table.Row>
              <Table.Cell>{data?.investigator?.name}</Table.Cell>
              <Table.Cell>{data?.approvedExpense}</Table.Cell>
              <Table.Cell>{data?.documentExpense}</Table.Cell>
              <Table.Cell>{data?.extraExpense}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      )))}

      {console.log(model.getType().getInitialCasePortionCapping())}

      {/*<Button basic color='blue' size='small' onClick={() => setHidden(!hidden)}>{hidden ? 'Show more' : 'Show less'}</Button>*/}
    </>
  );
};
const formatBytes = (a: number, b = 2) => {
  if (0 === a) return "0 Bytes";
  const c = 0 > b ? 0 : b,
    d = Math.floor(Math.log(a) / Math.log(1024));
  return (
    parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
    " " +
    ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  );
};

export default React.memo(CaseSummary);
